<ng-template #templateRef>
    <h2 mat-dialog-title>{{Copy.Code}} - {{Copy.Description}} (Currency: {{Copy.Currency?.Value}})</h2>
    <mat-dialog-content *ngIf="Copy">
        <table class="mat-mdc-table">
            <tr>
                <th>Article code</th>
                <th>Commercial name</th>
                <th>Price</th>
            </tr>
            <tr *ngFor="let row of Copy.PriceListDetails">
                <td>{{row.Article.Code}}</td>
                <td>{{row.Article?.CommercialName}}</td>
                <td>{{row.Price | number:'1.2-2'}} {{Copy.Currency?.Value}}</td>
            </tr>
        </table>
    </mat-dialog-content>
    <mat-dialog-actions>
        <div class="fill-remaining-space"></div>
        <button type="button" mat-button mat-raised-button mat-dialog-close>Close</button>
    </mat-dialog-actions>
</ng-template>
